/** «Телефония»: номера АТС voip-2 ↔ сотрудники, кто на линии, задачи коллегам из звонков робота.
 * `GET /api/telephony/extensions`, `GET|POST /api/telephony/problems`. */
import { apiFetch } from "@/lib/api";
import type { CallProblem } from "@/lib/voiceLab";

export type PbxUser = { id: number; name: string; active: number | boolean; loc: number; hours: number; calls: number };
export type PbxRow = {
  number: string;
  name: string;
  tech: string;
  state: "online" | "offline" | "unknown";
  closed: string | null;
  service: boolean;
  known: string | null;
  online_at: string | null;
  user: PbxUser | null;
  alarm: string | null;
};
export type PbxReport = {
  rows: PbxRow[];
  no_number: Omit<PbxUser, "loc">[];
  online: number;
  synced_at: string | null;
  source: "snapshot" | "ari";
};

export const extensionsQuery = () => ({
  queryKey: ["telephony-extensions"],
  queryFn: () => apiFetch<PbxReport>("/api/telephony/extensions"),
});

export const problemsQuery = (status: "new" | "done" | null) => ({
  queryKey: ["telephony-problems", status],
  queryFn: () => apiFetch<{ rows: CallProblem[] }>(`/api/telephony/problems${status ? `?status=${status}` : ""}`),
});

export const closeProblem = (id: number, body: { done: boolean; comment: string | null }) =>
  apiFetch<{ id: number }>(`/api/telephony/problems/${id}`, { method: "POST", body: JSON.stringify(body) });
